import 'babel-polyfill'; // Webpack needs
// import { startWith }  from 'lodash';

///////////////////// RAILS UJS /////////////////////////
/////////////////////////////////////////////////////////
import Rails from 'rails-ujs';
Rails.start();

///////////////////// GLOBAL LIBS ///////////////////////
/////////////////////////////////////////////////////////
// import TweenLite      from 'dy-local-libs/TweenLite';
// import TimelineMax    from 'dy-local-libs/TimelineMax';
// import CSSPlugin      from 'dy-local-libs/CSSPlugin';
// import ScrollToPlugin from 'dy-local-libs/ScrollToPlugin';
// import DrawSVGPlugin  from 'dy-local-libs/DrawSVGPlugin';


///////////////////// HELPERS ///////////////////////////
/////////////////////////////////////////////////////////
import Ajax                  from '../front/js/helpers/Ajax';
import Device                from '../front/js/helpers/Device';
import Cookies               from '../front/js/helpers/Cookies';
import Scroller              from '../front/js/helpers/Scroller';
import LazyLoading           from '../front/js/helpers/LazyLoading';
import States                from '../front/js/helpers/StatesMachine';
// import Pjax                  from '../front/js/helpers/Pjax';
import Parser                from '../front/js/helpers/Parser';
// import Animation             from '../front/js/helpers/Animation';
import HandyFunctions        from '../front/js/helpers/HandyFunctions';


///////////////////// COMPONENTS ////////////////////////
/////////////////////////////////////////////////////////
// import Parallax            from '../front/js/components/Parallax';
import Navbar                from '../front/js/components/Navbar';
import Banner                from '../front/js/components/Banner';
import Dropdown              from '../front/js/components/Dropdown';
import Header                from '../front/js/components/Header';
import HeaderProduct         from '../front/js/components/HeaderProduct';
import InputEmail            from '../front/js/components/InputEmail';
import BillingCheckbox       from '../front/js/components/BillingCheckbox';
import DropdownLanguages     from '../front/js/components/DropdownLanguages';
import Form                  from '../front/js/components/Form';
import InputPassword         from '../front/js/components/InputPassword';
import InputRadio            from '../front/js/components/InputRadio';
import InputSearch           from '../front/js/components/InputSearch';
import InputSelect           from '../front/js/components/InputSelect';
import InputSubmit           from '../front/js/components/InputSubmit';
import ModalTrigger          from '../front/js/components/ModalTrigger';
import Product               from '../front/js/components/Product';
import SliderFeatured        from '../front/js/components/SliderFeatured';
import SliderHeader          from '../front/js/components/SliderHeader';
import SliderProductImages   from '../front/js/components/SliderProductImages';
import SliderRecommended     from '../front/js/components/SliderRecommended';
import SliderVertical        from '../front/js/components/SliderVertical';
import SliderTabs            from '../front/js/components/SliderTabs';
import Accordion             from '../front/js/components/Accordion';
import AccordionRadio        from '../front/js/components/AccordionRadio';
import FilterPrice           from '../front/js/components/FilterPrice';
import Filter                from '../front/js/components/Filter';
import ProductImageThumbnail from '../front/js/components/ProductImageThumbnail';
import Cart                  from '../front/js/components/Cart';
import FormSignUp            from '../front/js/components/FormSignUp';
import Toast                 from '../front/js/components/Toast';
import TextArea              from '../front/js/components/TextArea';
import Video                 from '../front/js/components/Video';


///////////////////// CONSTRUCTOR ///////////////////////
/////////////////////////////////////////////////////////
class Project {
  constructor() {
    this.device      = new Device();
    this.states      = new States();
    this.parser      = new Parser();
    this.ajax        = new Ajax();
    this.components  = {};
  }
}



////////////////////// PAGE LOAD ////////////////////////
/////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  checkIfCookiesAccepted();

  window.app      = new Project();
  app.scroller    = new Scroller();
  app.lazyLoading = new LazyLoading();
  // app.pjax        = new Pjax();

  app.enhancedEcommerce = document.body.getAttribute('data-enhanced-ecommerce') === 'true';


  // Tracking current URL
  window.currentPage  = '';
  window.previousPage = '';
  window.setCurrentPage = () => {
    previousPage = currentPage;
    currentPage  = document.body.getAttribute('data-url');
  }
  setCurrentPage();


  //           Fade in page content        \\
  // ______________________________________//
  const pjaxContent = document.getElementsByClassName('pjax-content')[0];
  pjaxContent.classList.add('visible');


  ////////////////// ADDING COMPONENTS ////////////////////
  /////////////////////////////////////////////////////////
  app.components.navbar         = new Navbar();
  app.components.banner         = new Banner('cmp-banner');
  app.components.dropdown       = new Dropdown('cmp-dropdown');
  app.components.header         = new Header('cmp-header');
  app.components.headerproduct  = new HeaderProduct('cmp-header-product');
  app.components.modalTrigger   = new ModalTrigger('cmp-modal-trigger');
  app.components.cart           = new Cart('cmp-cart');
  app.components.product        = new Product('cmp-product');
  app.components.accordion      = new Accordion('cmp-accordion-trigger');
  app.components.accordionRadio = new AccordionRadio('cmp-accordion-radio-trigger');
  app.components.filter         = new Filter('cmp-filter');
  app.components.signUp         = new FormSignUp('cmp-signup');
  app.components.toast          = new Toast('cmp-toast');
  app.components.FilterPrice    = new FilterPrice('cmp-price-filter');
  app.components.dropdownLanguages     = new DropdownLanguages('cmp-dropdown-languages');
  app.components.sliderHeader          = new SliderHeader('cmp-slider-header');
  app.components.sliderFeatured        = new SliderFeatured('cmp-slider-featured');
  app.components.sliderProductImages   = new SliderProductImages('cmp-slider-product-images');
  app.components.sliderRecommended     = new SliderRecommended('cmp-slider-recommended');
  app.components.sliderVertical        = new SliderVertical('cmp-slider-vertical');
  app.components.sliderTabs            = new SliderTabs('cmp-slider-tabs');
  app.components.productImageThumbnail = new ProductImageThumbnail('cmp-product-img-thumbnail');
  app.components.form                  = new Form('cmp-form');
  app.components.billingCheckbox       = new BillingCheckbox('cmp-input-checkbox');
  app.components.inputEmail            = new InputEmail('cmp-input-email');
  app.components.inputPassword         = new InputPassword('cmp-input-password');
  app.components.inputRadio            = new InputRadio('cmp-input-radio');
  app.components.inputSearch           = new InputSearch('cmp-input-search');
  app.components.inputSelect           = new InputSelect('cmp-input-select');
  app.components.TextArea              = new TextArea('cmp-text-area');
  app.components.inputSubmit           = new InputSubmit('cmp-input-submit');
  app.components.video                 = new Video('cmp-video');


  if(!app.device.mobileOrTablet) {
    app.scroller.update();
    app.scroller.addListener();
    app.scroller.checkURL();
  }

  const dropdown = document.getElementsByClassName('dropdown-list')[0];
  const newDropdown = document.querySelector(`div[data-target="dropdown--products"]`);
  const navbar   = document.getElementsByClassName('navbar')[0];
  const links    = document.getElementsByClassName('cmp-dropdown');
  const otherLinks = document.getElementsByClassName('main-link');

  if(navbar) {
    navbar.addEventListener('mouseleave', (e) => {
      dropdown.classList.remove('visible');

      for(let link of links) {
        link.classList.remove('being-hovered');
      }
    });

    for(let link of otherLinks) {
      link.addEventListener('mouseover', (e) => {
        if(!link.classList.contains('cmp-dropdown')) {
          for(let dropdownTrigger of links) {
            dropdownTrigger.classList.remove('being-hovered');
            dropdown.classList.remove('visible');
            newDropdown.classList.remove('visible');
          }
        }
      })
    }
  }



  // code to avoid the navbar ghost on media query while resizing
  let previousMq = window.innerWidth;
  let currentMq;

  const breakpoint = [1141, 1199];
  const navbarContentWrap = document.getElementsByClassName('navbar-contents-wrapper')[0];

  window.addEventListener('resize', function() {
    currentMq = window.innerWidth;

    if((currentMq == breakpoint[0] ||                                                             // match scss mq
      (previousMq < currentMq) && (previousMq < breakpoint[0]) && (breakpoint[0] < currentMq) ||    // resize up
      (previousMq > currentMq) && (currentMq < breakpoint[0])  && (breakpoint[0] < previousMq)      // resize down
    ) || (currentMq == breakpoint[1] ||                                                             // match scss mq
      (previousMq < currentMq) && (previousMq < breakpoint[1]) && (breakpoint[1] < currentMq) ||    // resize up
      (previousMq > currentMq) && (currentMq < breakpoint[1])  && (breakpoint[1] < previousMq)      // resize down
    )) {
      navbarContentWrap.style.display = 'none';
      setTimeout(function(){
        navbarContentWrap.style.display = 'block'
      }, 500);
    }

    previousMq = currentMq;
  })

  // set the the scroll to go to the top on every page
    const element = document.getElementsByClassName('main-content')[0];
    const goToTop = element.scrollTop;
    //console.log("Scroll from Top: " + goToTop);

    window.scrollTo(0, goToTop);




  //     TPV      \\
  // _____________//
  // submit Form to load TPV modal //
  // ------------------------------//
  const tpvForm = document.getElementById('confirm-order');
  if(!!tpvForm) {
    tpvForm.submit();

    // Listener to the TVP //
    // --------------------//
    function receiveMessage(e) {
      // TODO If we have multiples message we could split
      // the actions base on the event origin (contains the emisor URL)

      if (!_.startsWith(e.data, 'Error:')) {
        const data     = app.parser.parseJSON(e.data);
        const height   = !!data.iframe ? data.iframe.height : null;
        // const width    = !!data.iframe ? data.iframe.width : null;
        const sha1hash = data.SHA1HASH;
        const modalTPV = document.getElementsByClassName('modal--tpv')[0];

        if(!!modalTPV && !!height) {
          const modalContent = modalTPV.getElementsByClassName('modal-content')[0];
          if(!!modalContent) {
            if(window.innerHeight >= parseInt(height)) {
              modalContent.style.height = (parseInt(height) + 5 + 'px');
            } else {
              modalContent.style.height = '100%';
            }
          }
        }

        if(!!modalTPV && !!sha1hash) {
          const url = tpvForm.getAttribute('data-server-post');
          let dataDecoded = {};
          Object.keys(data).forEach(function(key,index) {
            dataDecoded[key] = window.atob(data[key]);
          });
          postTPVResponse(url, dataDecoded);
        }
      } else {
        const url = tpvForm.getAttribute('data-server-post');
        let obj = {};
        obj['ORDER_ID']    = tpvForm.getAttribute('data-order-code');
        obj['SHA1HASH']    = '';
        obj['TIMESTAMP']   = '';
        obj['MERCHANT_ID'] = '';
        obj['RESULT']      = '';
        obj['MESSAGE']     = '';
        obj['PASREF']      = '';
        obj['AUTHCODE']    = '';
        postTPVResponse(url, obj);
      }

      function postTPVResponse(url, data) {
        var f = document.createElement('form');
        f.setAttribute('method','post');
        f.setAttribute('action',url);
        f.classList.add('hidden');

        Object.keys(data).forEach(function(key,index) {
          var i = document.createElement('input'); //input element, text
          i.setAttribute('type','hidden');
          i.setAttribute('name',key);
          i.setAttribute('value',data[key]);
          f.appendChild(i);
        });

        document.getElementsByTagName('body')[0].appendChild(f);
        f.submit();
      }
    }

    if (window.addEventListener) {
      window.addEventListener('message', receiveMessage, false);
    } else {
      window.attachEvent('message', receiveMessage);
    }
  }



  // GoToReview Tab
  const btnReview = document.getElementById('btn--review');
  if(btnReview) {
    btnReview.addEventListener('click', () => {
      const checkbox = document.getElementById('tab-button-8');
      checkbox.checked = true;
      checkbox.setAttribute('checked', true);

      const tabReview = document.getElementById('content-8');
      app.scroller.scrollTo(tabReview);
    })

  }



  // LOTTIE ADVENT_CALENDAR
  // https://github.com/airbnb/lottie-web
  window.startLottiePromo = () => {
    const openGift = document.getElementById('open-gift');
    const fade = document.getElementsByClassName('calendar-advent-fade')[0];
    const AventCta = document.getElementsByClassName('calendar-advent-cta-wrapper')[0];
    const AventActions = document.getElementsByClassName('calendar-advent-action-wrapper')[0];
    if (openGift) {
      setTimeout(() => {
        lottie.play();
        setTimeout(() => {
          lottie.goToAndStop(120, true);
        }, 4000);

        openGift.addEventListener('click', () => {
          openGift.parentElement.classList.add('disabled');

          // Open door animation
          lottie.play();
          setTimeout(() => {
            // Init fade to white
            fade.classList.add('fade-in');
            setTimeout(() => {
              // Fade out after 'fade' element transition-duration ( see scss value)
              lottie.goToAndStop(60, true);
              fade.classList.remove('fade-in');
              AventCta.classList.add('visible');
              AventActions.classList.add('visible');
            }, 210 + 1000/30*16);
          }, 1000/30*7);

        });
      }, 450);
    }
  }
  // LOTTIE END

  // CHECK FOR PROMOTIONS PROGRESSION
  app.ajax.rails(window.promotionsProgress, 'GET');
});
